import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnnualMinimumDetails } from '../../../../models/transactions/annual-minimum-details';

@Component({
  selector: 'app-member-vb-account-config-account-details-card',
  templateUrl: './member-vb-account-config-account-details-card.component.html',
  styleUrls: ['./member-vb-account-config-account-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberVbAccountConfigAccountDetailsCardComponent implements OnChanges {
  @Input({ required: true }) effectiveDate: string = '';
  @Input({ required: true }) combinedVbAccountBalance: number = 0;
  @Input({ required: true }) desiredFundingAmount: number = 0;
  @Input({ required: true }) useEntireBalance: boolean = false;
  @Input({ required: true }) estimatedAnnualTotal: number = 0;
  @Input({ required: true }) annualMinimumDetails!: AnnualMinimumDetails;

  public effectiveDateAsterisks = '*';
  public minimumAgePrefix = '';

  public combinedBalanceTooltip = $localize`This includes the existing balance, plus new assets being brought into the variable benefit account`;
  public effectiveDateTooltip = $localize`When new assets will be transferred to the Variable Benefit account`;
  public estimatedAnnualTotalTooltip = $localize`This figure reflects all payments made to date in the current year, combined with upcoming recurring and lump sum payments planned for this VB account.`;
  public annualMinimumTooltip = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.useEntireBalance) {
      this.effectiveDateAsterisks = this.useEntireBalance ? '**' : '*';
    }

    if (changes.annualMinimumDetails) {
      this.minimumAgePrefix = this.annualMinimumDetails?.isSpouse ? $localize`Spouse` : $localize`Member`;
      this.annualMinimumTooltip = this.annualMinimumDetails?.isEstimated
        ? $localize`The minimum total payment amount required for the year, based on estimates from the previous year for the variable benefit account balance(s) and the selected minimum age(s)`
        : $localize`The minimum total payment amount required for the year, based on the Variable Benefit Account balance at the start of the year and the selected minimum age.`;
    }
  }
}
